import React from 'react'

const Gallery = () => {
  return (
    <div className="container">
        <div className="py-4">
            <h1 className="text-uppercase text-centre display-3">My Gallery</h1>
            <hr className="text-centre w-25 border-dark" />
        </div>
        <div className="row no-gutters gallerys">
            <div className="col-lg-4 col-md-4 col-sm-6 col-12  man">
                <a href="https://scontent.fbom12-1.fna.fbcdn.net/v/t1.6435-9/107887080_191714628964368_8757595222361300227_n.jpg?_nc_cat=102&ccb=1-6&_nc_sid=973b4a&_nc_ohc=EtuvWwV3VV4AX_ovuNd&_nc_ht=scontent.fbom12-1.fna&oh=00_AT_IBe9zo93lOSxKAuuNytgQg8zjbFQVx2Ah6Byv9RNFOg&oe=62A7DA58"
                    target="_blank"><img
                        src="https://images.unsplash.com/photo-1601635821388-12e3b455d75e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDF8eEh4WVRNSExnT2N8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60"
                        className="img-fluid " alt="" /></a>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6 col-12 man">
                <a href="https://4.imimg.com/data4/DQ/JW/GLADMIN-%2024262688/83-500x500.jpg" target="_blank"><img
                        src="https://4.imimg.com/data4/DQ/JW/GLADMIN-%2024262688/83-500x500.jpg" className="img-fluid "
                        alt="" /></a>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6 col-12 man">
                <a href="https://images.unsplash.com/photo-1599662875272-64de8289f6d8?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTA5fHxmYXNoaW9ufGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                    target="_blank"><img
                        src="https://images.unsplash.com/photo-1599662875272-64de8289f6d8?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTA5fHxmYXNoaW9ufGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                        className="img-fluid " alt="" /></a>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6 col-12 man">
                <a href="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWdQQeGuag8JlAyiZzArqLDDqF_9hz2UdVtA&usqp=CAU"
                    target="_blank"><img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWdQQeGuag8JlAyiZzArqLDDqF_9hz2UdVtA&usqp=CAU"
                        className="img-fluid " alt="" /></a>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6 col-12 man">
                <a href="https://m.media-amazon.com/images/I/61Z7xIZS0EL._UL1080_.jpg" target="_blank"><img
                        src="https://m.media-amazon.com/images/I/61Z7xIZS0EL._UL1080_.jpg" className="img-fluid "
                        alt="" /></a>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6 col-12 man">
                <a href="https://i.pinimg.com/736x/b9/d8/c0/b9d8c08b2d9d42159488a3ac353d843f.jpg" target="_blank"><img
                        src="https://i.pinimg.com/736x/b9/d8/c0/b9d8c08b2d9d42159488a3ac353d843f.jpg "
                        className="img-fluid " alt="" /></a>
            </div>





        </div>
    </div>
  )
}

export default Gallery
